/* eslint-disable react-hooks/exhaustive-deps */
import { Intent, Tag } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { ID } from "src/libs/interfaces/layouts"
import { wordTrim } from "src/libs/utilities"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import useLand from "src/modules/pe-basic-module/hooks/useLand"
import { IHoneycombs, IProject } from "src/modules/pe-fest-module/data/interfaces"
import { IFestMyProjectsProps, useFestMyProjects } from "src/modules/pe-fest-module/data/store"
import { IState, useMainStore } from "src/settings/zustand"

/* Protopia Ecosystem component */
export interface IHoneycombsPartnersProps {
   project: IProject
   honeycombs : IHoneycombs 
}
const HoneycombsPartners = (props: IHoneycombsPartnersProps): JSX.Element => {
    const _landId : ID = useMainStore((state:IState) => state.landId )
    const myProjects: IProject[] = useFestMyProjects((state: IFestMyProjectsProps) => state.myProjects)
    const [projects, setProjects] = useState<IProject[]>([])
    useEffect(() => {
        if(props.honeycombs.id) {
            actions(
                GET_FEED_ACTION,
                {
                    land_id : _landId, 
                    data_type: "PEFestProject",
                    seed: "project-honeycombs-" + props.honeycombs.id, 
                    paging: `taxonomies:[ {tax_name: "fmru_honeycombs", term_ids: [ ${props.honeycombs.id} ] }],  order_by_meta: "title" , order: "ASC", search:""`
                }).then((response: any) => {                   
                    setProjects( response.feed ) 
                })
        }
    }, [ ])

    const isMine = (id: ID): boolean => {
        return myProjects.map(p => p.id).includes(id)
    } 
    
    return <div className='pe-honeycombs-partners-container'>
       {
            props.honeycombs.id && projects.length > 0
                ?
                projects.map(project => {
                    return project.id !== props.project.id
                        ?
                        <Link key={project.id} to={`/fest/${ _landId }/project/${project.id}/`}>
                            <Tag className="mr-1 mb-1 " intent={isMine(project.id) ? Intent.DANGER : Intent.NONE}> 
                                { wordTrim( project.title, 5 ) }
                            </Tag>
                        </Link>
                        : 
                        <Tag className="mr-1 mb-1 opacity_5"  intent={isMine(project.id) ? Intent.DANGER : Intent.NONE} key={project.id}> 
                            { wordTrim( project.title, 5 )  }
                        </Tag>
                })
                :
                <></>
       }
    </div>
}
export default HoneycombsPartners